import React from 'react';
import ReactDOM from 'react-dom/client';
import HotelManagementApp from './App';
// Bootstrap i18next once at app start. Pulls translation JSON from
// /public/locales/{lng}/{ns}.json on demand. See src/i18n/index.js for
// the resolution chain (localStorage → ?lng → navigator → English).
import './i18n';
import {
  DisplaySettingsProvider,
  DisplayChakraProvider,
  applyRootFontSize,
  readStoredScale,
} from './context/DisplaySettingsContext';

// Apply the stored text-size BEFORE first paint so the UI never flashes
// small and then jumps to the user's chosen size.
applyRootFontSize(readStoredScale());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DisplaySettingsProvider>
      <DisplayChakraProvider>
        <HotelManagementApp />
      </DisplayChakraProvider>
    </DisplaySettingsProvider>
  </React.StrictMode>
);
